import { InfoOutlined } from '@mui/icons-material';
import { Alert, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { TaskTemplateLink } from '../../../types/TaskTemplate';
import { Nullable } from '../../../types/utils';
import { humanizeDate, offsetToText } from '../../../utility/dateUtils';
import { StartConditionType } from '../../../utility/startCondition';
import { DependencyOption } from '../../tasks/StartCondition';

interface TaskSummaryProps {
  modalState: Nullable<TaskTemplateLink>;
  startCondType: StartConditionType;
  dependencyOptions: DependencyOption[];
}


export default function TaskSummary({ modalState, startCondType, dependencyOptions }: TaskSummaryProps) {
  if (!modalState.task_template_name) return null;

  const name = modalState.task_template_name;

  const clauses: React.ReactNode[] = [];

  if (modalState.assigned_to_display_name)
    clauses.push(
      <>
        is assigned to <strong>{modalState.assigned_to_display_name}</strong>
      </>
    );

  if (startCondType === 'date' && modalState.start_date) {
    clauses.push(
      <>
        starts on <strong>{humanizeDate(modalState.start_date)}</strong>
      </>
    );
  } else if (startCondType === 'offset' && !_.isNil(modalState.start_date_offset)) {
    clauses.push(
      <>
        starts <strong>{offsetToText(modalState.start_date_offset)}</strong>
      </>
    );
  } else if (startCondType === 'dependency' && modalState.depends_on_uuid) {
    const dep = _.find(dependencyOptions, { uuid: modalState.depends_on_uuid });
    if (dep)
      clauses.push(
        <>
          starts after <strong>{dep.name}</strong> is completed
        </>
      );
  }

  if (!_.isNil(modalState.due_date_offset))
    clauses.push(
      <>
        {clauses.length > 0 ? 'and is due' : 'is due'} <strong>{offsetToText(modalState.due_date_offset)}</strong>
      </>
    );

  const joined = clauses.flatMap((clause, i) => (i === 0 ? [clause] : [', ', clause]));

  return (
    <Alert icon={<InfoOutlined fontSize="small" color="info" />} sx={{ bgcolor: 'grey.100', color: 'text.secondary', boxShadow: 'none', alignItems: 'center' }}>
      <Typography variant="body2">
        <strong>{name}</strong> {joined}.
      </Typography>
    </Alert>
  );
}
